import { gql } from '@apollo/client'

import { featuredEditFieldsFragment } from 'js/lib/fragments/FeaturedEditFields.fragment'
import { ownerIdentityFieldsFragment } from 'js/lib/fragments/OwnerIdentityFields.fragment'

export const magazineArticleEditFragment = gql`
    fragment MagazineArticleEdit on Blog {
        guid
        abstract
        canEditAdvanced
        title
        url
        richDescription
        backgroundColor
        canEdit
        statusPublished
        canArchiveAndDelete
        inputLanguage
        isTranslationEnabled
        subtype
        featured {
            ...FeaturedEditFields
        }
        showOwner
        owner {
            ...OwnerIdentityFields
        }
    }
    ${featuredEditFieldsFragment}
    ${ownerIdentityFieldsFragment}
`
